class Object2D {
    isObject2D = true;

    userData = {};

    constructor() {
      this.type = 'Object2D';
    }

    type: string;
}

export default Object2D;
